import {useMemo} from 'react';
import {
  FORM_TYPE_INQUIRY,
  FORM_TYPE_REPORT,
  FORM_TYPE_ILLEGAL,
} from '@/constants/help/form';
import {
  FormType,
  DefaultFormFieldValues,
  ReportFormFieldValues,
  IllegalFormFieldValues,
  ObjectionFormFieldValues,
} from '@/components/help/common/FormContainer/types';
import {ILLEGAL_MAIN_CATEGORY, OBJECTION_NODE_ID} from '@/constants/help/index';
import {useMobileInfo} from './useMobileInfo';

interface UseFormDefaultValuesProps {
  type: FormType;
}

export const useFormDefaultFieldValues = ({
  type,
}: UseFormDefaultValuesProps) => {
  const mobileInfo = useMobileInfo();

  const defaultFieldValues = useMemo<DefaultFormFieldValues>(() => {
    // 폼에 공통으로 들어가는 기본값
    const commonDefaults = {
      osInfo: mobileInfo,
      customerEmail: '',
      title: '',
      content: '',
      attachedFiles: [],
      agreement: false,
    };

    if (type === FORM_TYPE_INQUIRY) {
      // 문의하기 폼 기본값
      return {
        ...commonDefaults,
        mainCategory: '',
        subCategory: '',
      } as DefaultFormFieldValues;
    } else if (type === FORM_TYPE_REPORT) {
      // 신고하기 폼 기본값
      return {
        ...commonDefaults,
        mainCategory: '',
      } as ReportFormFieldValues;
    } else if (type === FORM_TYPE_ILLEGAL) {
      // 불법촬영물 신고 폼 기본값
      return {
        ...commonDefaults,
        mainCategory: ILLEGAL_MAIN_CATEGORY[0].value,
        subCategory: '',
        reporterName: '',
        birth: '',
        phoneNumber: '',
      } as IllegalFormFieldValues;
    } else {
      // 이의신청 폼 기본값
      return {
        ...commonDefaults,
        mainCategory: OBJECTION_NODE_ID,
      } as ObjectionFormFieldValues;
    }
  }, [mobileInfo, type]);

  return defaultFieldValues;
};
